import React, { useEffect } from "react"
import SEO from "../../seo"
import { Container, Col } from "react-bootstrap"
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import PolicyInformation from "./PolicyInformation"
import DriverInformation from "./DriverInformation"
import RequiredDocuments from "./RequiredDocuments"
import ParticularsOfAccident from "./ParticularsOfAccident"
import ReviewClaim from "./ReviewClaim"
import SubmittedClaim from "./SubmittedClaim"
import * as API from "../../../services/httpService"
import {
  saveDataFromAPI,
  controlLoading,
} from "../../../Redux/WindscreenClaim/actions"
import { navigate } from "gatsby"

const BaseForm = React.memo(() => {
  const uiData = useSelector(state => state.uiData)
  const { maxPageNumber } = uiData
  const dispatch = useDispatch()

  const claimData = useSelector(state => state.claimData, shallowEqual)

  useEffect(() => {
    dispatch(controlLoading())

    const WorkshopPromise = API.apiPostRequest("/Claim/Workshop", null, null)

    const OccupationPromise = API.apiPostRequest(
      "/Claim/Occupation",
      null,
      null
    )

    const WindscreenItemTypePromise = API.apiPostRequest(
      "/Claim/WindscreenItemType",
      null,
      null
    )

    Promise.all([WorkshopPromise, OccupationPromise, WindscreenItemTypePromise])
      .then(values => {
        if (values[0].data) {
          let workshopList = [...values[0].data]

          let othersWorkshopIndex = workshopList
            .map(function(e) {
              return e.Workshop
            })
            .indexOf("Others")

          if (othersWorkshopIndex !== -1) {
            workshopList[othersWorkshopIndex].ID = 0 // Set Others workshop ID to 0
          }

          dispatch(saveDataFromAPI("workshopList", workshopList))
        }
        if (values[1].data) {
          let occupationList = [...values[1].data]
          let otherIndex = occupationList
            .map(function(e) {
              return e.Occupation
            })
            .indexOf("Others")

          //Move "Others" to last place
          occupationList.push(occupationList.splice(otherIndex, 1)[0])

          dispatch(saveDataFromAPI("occupationList", occupationList))
        }
        if (values[2].data) {
          dispatch(saveDataFromAPI("descOfDamageList", values[2].data))
        }
        dispatch(controlLoading())
      })
      .catch(error => {
        navigate("ErrorOccurred")
      })
  }, shallowEqual)

  return (
    <>
      <SEO title="Windscreen Claim" />{" "}
      <Container className="body-content mt-md-4">
        {/* Pages
          1 Workshop and policy information + detail of policy
          2 Document upload
          3 Particulars of Driver
          4 Particulars of Accident + Repair Estimate + Nature of Damage
          5 Summary
          6 Submitted result 
        */}

        <Col xs={12}>
          {/* 5 Summary */}
          {maxPageNumber >= 5 && (
            <ReviewClaim claimData={claimData} uiData={uiData} />
          )}

          {/* 1 Workshop and policy information + detail of policy */}
          {maxPageNumber >= 1 && (
            <PolicyInformation claimData={claimData} uiData={uiData} />
          )}

          {/* 2 Document upload */}
          {maxPageNumber >= 2 && (
            <RequiredDocuments claimData={claimData} uiData={uiData} />
          )}

          {/* 3 Particulars of Driver */}
          {maxPageNumber >= 3 && (
            <DriverInformation claimData={claimData} uiData={uiData} />
          )}

          {/* 4 Particulars of Accident + Repair Estimate + Nature of Damage */}
          {maxPageNumber >= 4 && (
            <ParticularsOfAccident claimData={claimData} uiData={uiData} />
          )}

          {/* 6 Submitted result */}
          {maxPageNumber === 6 && (
            <SubmittedClaim uiData={uiData}></SubmittedClaim>
          )}
        </Col>
      </Container>
    </>
  )
})

export default BaseForm
